// packages/eden-text/src/components/shared.js
import { css } from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
var shared = css`
  margin: 0;

  & > :first-child {
    margin-block-start: 0;
  }

  & > :last-child {
    margin-block-end: 0;
  }

  & > :first-child > :first-child {
    margin-block-start: 0;
  }

  & > :last-child > :last-child {
    margin-block-end: 0;
  }

  & ol,
  & ul {
    & li:not(:last-child) {
      margin-block-end: ${spacing8};
    }
  }

  & ol {
    list-style-type: decimal;

    & ol {
      list-style-type: upper-latin;

      & ol {
        list-style-type: upper-roman;

        & ol {
          list-style-type: lower-latin;
        }
      }
    }
  }

  & ul {
    list-style-type: disc;

    & ul {
      list-style-type: circle;

      & ul {
        list-style-type: square;
      }
    }
  }
`;
var shared_default = shared;
export {
  shared_default as default
};
